import { Field, FieldArray, ErrorMessage, FormikValues } from "formik";
import { containerInitialValues } from "../helpers/SalesInvoiceHelper";
import { Autocomplete, TextField } from "@mui/material";
import { ContainerSize } from "../../../../components/Enums";
import ReactSelect from "react-select";
import { n } from "../helpers/SalesInvoiceHelperFunction";

interface ContainerFieldsProps {
  permissions: any;
  productList: any;
  setAddProductModalStatus: any;
  values: FormikValues;
  setFieldValue: any;
  sealNumbersList: any;
  noOfContainers: string;
  setNoOfContainers: (value: string) => void;
  isShowContainerButton: any;
  setAddSealNumberModalStatus: (show: boolean) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  setIsShowContainerButton: any;
  setSelectedSealContainer: (val: {
    productIndex: number;
    containerIndex: number;
  }) => void;
}

const ContainerFields: React.FC<ContainerFieldsProps> = ({
  permissions,
  productList,
  setAddProductModalStatus,
  values,
  setFieldValue,
  sealNumbersList,
  noOfContainers,
  setNoOfContainers,
  isShowContainerButton,
  handleChange,
  setIsShowContainerButton,
  setAddSealNumberModalStatus,
  setSelectedSealContainer,
}) => {
  const updateValue = (key: string, val: any) => {
    const formatted = val && val > 0 ? +n(val).toFixed(3) : "";
    setFieldValue(key, formatted);
    return formatted;
  };

  const selectedProductsList = values.sales_invoice_products
    .map((p: any) => {
      const product = productList.find(
        (pr: any) =>
          pr.product_id === p.product_id &&
          pr.contract_id === p.sales_contract_id,
      );

      if (!product) return null;

      return {
        ...product,
        label: `${product.products?.name} - ${product.contract_no}`,
        value: `${product.product_id}_${product.contract_id}`,
      };
    })
    .filter(Boolean);

  const calculateNetAndGrossWeight = (containerIndex: number) => {
    const container = values.container[containerIndex];
    const productIndex = values.sales_invoice_products.findIndex(
      (p: any) =>
        p.product_id === container.product_id &&
        p.sales_contract_id === container.sales_contract_id,
    );
    const product = values.sales_invoice_products[productIndex];

    if (container && product) {
      updateValue(
        `container[${containerIndex}].total_net_weight`,
        n(container.no_of_bags) * n(product.packing_net_weight),
      );
      updateValue(
        `container[${containerIndex}].total_gross_weight`,
        n(container.no_of_bags) * n(product.packing_gross_weight),
      );
    } else {
      updateValue(`container[${containerIndex}].total_net_weight`, "");
      updateValue(`container[${containerIndex}].total_gross_weight`, "");
    }
  };

  return (
    <div className="card my-card">
      <div className="card-header my-card-header bg-lighter d-flex justify-content-between">
        <div>
          <h6 className="my-card-header-head">Containers</h6>
        </div>
        {isShowContainerButton && (
          <div>
            <button
              title="Add Containers"
              className="btn btn-sm btn-primary waves-effect waves-light p-0"
              type="button"
              style={{ margin: "5px" }}
              onClick={() => {
                setIsShowContainerButton(false);
              }}
            >
              <span>
                <i className="ti ti-plus my-card-icon-button"></i>
              </span>
            </button>
          </div>
        )}
      </div>
      {!isShowContainerButton && (
        <div className="card-body my-card-body">
          <FieldArray
            name="container"
            render={({ push, remove }) => (
              <>
                <div className="row g-3 m-0">
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                    <input
                      type="number"
                      min={1}
                      className="form-control dt-input dt-full-name"
                      placeholder="No. of containers"
                      value={noOfContainers}
                      onChange={(e) => {
                        setNoOfContainers(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        for (let i = 0; i < Number(noOfContainers); i++) {
                          push(containerInitialValues);
                        }
                        setNoOfContainers("");
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {values?.container?.length > 0 &&
                  values?.container.map((_: any, index: any) => (
                    <div className="sales_section_card" key={index}>
                      <div className="row g-3 m-0">
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <div className="d-flex justify-content-between">
                            <div>
                              <label
                                htmlFor={`container[${index}].product_id`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Product: <span className="text-danger">*</span>
                              </label>
                            </div>
                            {permissions.includes("create-product") && (
                              <div>
                                <button
                                  title="Add Product"
                                  className="btn btn-sm btn-primary waves-effect waves-light p-0"
                                  type="button"
                                  onClick={() => setAddProductModalStatus(true)}
                                >
                                  <span>
                                    <i className="ti ti-plus my-card-icon-button"></i>
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                          <Field
                            id={`container[${index}].product_id`}
                            name={`container[${index}].product_id`}
                          >
                            {({ field }: any) => {
                              const selectedOption = selectedProductsList.find(
                                (option: any) =>
                                  option.value ===
                                  `${values.container[index].product_id}_${values.container[index].sales_contract_id}`,
                              );
                              // const formatOptionLabel = (
                              //   option: any,
                              //   { context }: any,
                              // ) => {
                              //   if (context === "value") {
                              //     return option.name;
                              //   } else {
                              //     return (
                              //       <div>
                              //         <label className="form-label">
                              //           {option.name}
                              //         </label>{" "}
                              //         -{"  "}
                              //         <label className="form-label">
                              //           {option.variety}
                              //         </label>
                              //         <br />
                              //         <span className="form-label">
                              //           {option.description}
                              //         </span>
                              //       </div>
                              //     );
                              //   }
                              // };
                              return (
                                <>
                                  <ReactSelect
                                    classNamePrefix="react-select"
                                    placeholder="Select Product"
                                    options={selectedProductsList}
                                    getOptionLabel={(option: any) =>
                                      option.label
                                    }
                                    getOptionValue={(option: any) =>
                                      option.value
                                    }
                                    onChange={(selectedOption: any) => {
                                      if (!selectedOption) {
                                        setFieldValue(
                                          `container[${index}].product_id`,
                                          "",
                                        );
                                        setFieldValue(
                                          `container[${index}].sales_contract_id`,
                                          "",
                                        );
                                        return;
                                      }

                                      const [productId, contractId] =
                                        selectedOption.value.split("_");

                                      setFieldValue(
                                        `container[${index}].product_id`,
                                        productId,
                                      );
                                      setFieldValue(
                                        `container[${index}].sales_contract_id`,
                                        contractId,
                                      );

                                      setFieldValue(
                                        `container[${index}].no_of_bags`,
                                        "",
                                      );
                                      setFieldValue(
                                        `container[${index}].total_net_weight`,
                                        "",
                                      );
                                      setFieldValue(
                                        `container[${index}].total_gross_weight`,
                                        "",
                                      );
                                    }}
                                    value={selectedOption}
                                    isClearable
                                    isSearchable
                                  />
                                </>
                              );
                            }}
                          </Field>
                          <ErrorMessage
                            name={`container[${index}].product_id`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].container_no`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Container No: <span className="text-danger">*</span>
                          </label>
                          <Field
                            name={`container[${index}].container_no`}
                            type="text"
                            className="form-control"
                            placeholder="Enter Container No"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].container_no`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].lot_no`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Lot No:
                          </label>
                          <Field
                            name={`container[${index}].lot_no`}
                            type="text"
                            className="form-control"
                            placeholder="Enter Lot No"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].lot_no`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].lot_label_seal`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Lot Label Seal:
                          </label>
                          <Field
                            name={`container[${index}].lot_label_seal`}
                            type="text"
                            className="form-control"
                            placeholder="Enter Lot Label Seal"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].lot_label_seal`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].line_seal_no`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Line Seal No:
                          </label>
                          <Field
                            name={`container[${index}].line_seal_no`}
                            type="text"
                            className="form-control"
                            placeholder="Enter Line Seal No"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].line_seal_no`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <div className="d-flex justify-content-between">
                            <div>
                              <label
                                htmlFor={`container[${index}].self_seal_id`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Self Seal No:
                              </label>
                            </div>
                            {permissions.includes("create-seal-number") && (
                              <div>
                                <button
                                  title="Add Seal Number"
                                  className="btn btn-sm btn-primary waves-effect waves-light p-0"
                                  type="button"
                                  onClick={() => {
                                    setSelectedSealContainer({
                                      productIndex: index,
                                      containerIndex: index,
                                    });
                                    setAddSealNumberModalStatus(true);
                                  }}
                                >
                                  <span>
                                    <i className="ti ti-plus my-card-icon-button"></i>
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                          <Autocomplete
                            disablePortal
                            options={sealNumbersList.filter((seal: any) => {
                              const allSelectedSealIds = values.container
                                ? values.container
                                    .map(
                                      (container: any) =>
                                        container?.self_seal_id,
                                    )
                                    .filter(
                                      (id: any, idx: number, arr: any[]) =>
                                        id && arr.indexOf(id) === idx,
                                    )
                                : [];

                              const currentSealId =
                                values?.container?.[index]?.self_seal_id;
                              return (
                                seal.id === currentSealId ||
                                !allSelectedSealIds.includes(seal.id)
                              );
                            })}
                            getOptionLabel={(option: any) =>
                              option.seal_no || "No Seal"
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(e, newValue): any => {
                              setFieldValue(
                                `container[${index}].self_seal_id`,
                                newValue?.id || "",
                              );
                            }}
                            value={
                              sealNumbersList.find(
                                (item: any) =>
                                  item.id ===
                                  values.container[index].self_seal_id,
                              ) || null
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                className="form-control"
                                type="text"
                                placeholder="Enter Name"
                              />
                            )}
                          />

                          <ErrorMessage
                            name={`container[${index}].self_seal_id`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].sticker_no`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Sticker No:{" "}
                          </label>
                          <Field
                            name={`container[${index}].sticker_no`}
                            type="text"
                            className="form-control"
                            placeholder="Enter Sticker No"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].sticker_no`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].vehicle_no`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Vehicle No:
                          </label>
                          <Field
                            name={`container[${index}].vehicle_no`}
                            type="text"
                            className="form-control"
                            placeholder="Enter Vehicle No"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].vehicle_no`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].size`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Size:{" "}
                          </label>
                          <select
                            id={`container[${index}].size`}
                            name={`container[${index}].size`}
                            className="form-control"
                            value={values.container[index].size || undefined}
                            onChange={handleChange}
                          >
                            <option defaultChecked value={""}>
                              Select Container Size{""}
                            </option>
                            <option value={ContainerSize.TWENTY}>
                              {ContainerSize.TWENTY}
                            </option>
                            <option value={ContainerSize.FORTY}>
                              {ContainerSize.FORTY}
                            </option>
                          </select>
                          <ErrorMessage
                            name={`container[${index}].size`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].no_of_bags`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            No of Bags:
                          </label>
                          <Field
                            name={`container[${index}].no_of_bags`}
                            type="number"
                            className="form-control"
                            placeholder="Enter No of Bags"
                            value={values?.container[index].no_of_bags || ""}
                            onChange={(e: any) => {
                              values.container[index].no_of_bags = updateValue(
                                e.target.name,
                                e.target.value,
                              );
                              calculateNetAndGrossWeight(index);
                            }}
                          />
                          <ErrorMessage
                            name={`container[${index}].no_of_bags`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].total_net_weight`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Total Net Weight (KGS):
                          </label>
                          <Field
                            name={`container[${index}].total_net_weight`}
                            type="number"
                            className="form-control"
                            placeholder="Enter Total Net Weight (KGS)"
                            value={
                              values?.container[index].total_net_weight || ""
                            }
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].total_net_weight`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].total_gross_weight`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Total Gross Weight (KGS):
                          </label>
                          <Field
                            name={`container[${index}].total_gross_weight`}
                            type="number"
                            className="form-control"
                            placeholder="Enter Total Gross Weight (KGS)"
                            value={
                              values?.container[index].total_gross_weight || ""
                            }
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].total_gross_weight`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label
                            htmlFor={`container[${index}].remark`}
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Remark:
                          </label>
                          <Field
                            name={`container[${index}].remark`}
                            type="text"
                            className="form-control"
                            placeholder="Enter Remark"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name={`container[${index}].remark`}
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <i
                          title="Remove Container"
                          className="fa-solid fa-xmark sales_document_btn"
                          onClick={() => {
                            remove(index);
                          }}
                        ></i>
                      </div>
                    </div>
                  ))}

                <div className="row m-2 justify-content-end">
                  <button
                    title="Add Container"
                    type="button"
                    className="btn btn-primary col-12 col-sm-auto"
                    onClick={() => {
                      push(containerInitialValues);
                    }}
                  >
                    Add Container
                  </button>
                </div>
              </>
            )}
          />
        </div>
      )}
    </div>
  );
};
export default ContainerFields;
